import { Component, ElementRef, Input, OnInit, Renderer2, ViewChild } from '@angular/core';
import { FilterType } from '../../models/filter-type';
import { CommonService } from '../../services/common.service';
import { event } from 'jquery';

interface FiltersData {
  data: any,
  showClearAllFilters: boolean,
  showCount: boolean,
  displayLimitedFilters: boolean,
}

interface FilterCollapse {
  name: string;
  isCollapsed: boolean;
}

@Component({
  selector: 'app-filters',
  templateUrl: './filters.component.html',
  styleUrls: ['./filters.component.scss']
})
export class FiltersComponent implements OnInit {

  @Input() filtersData: FiltersData = {
    data: [],
    showClearAllFilters: false,
    showCount: false,
    displayLimitedFilters: false,
  };
  @ViewChild('clearStatus', { static: false }) clearStatus!: ElementRef;
  window: any = window;

  public accordianIsExpanded: boolean = true;
  public collapsePanel: boolean = false;
  public checkedFiltersList: FilterType[] =  [];
  public selectedFilterType: any = {};
  public currentClickedFilter: FilterCollapse = {name: '', isCollapsed: false};
  public showFilters: boolean = false;

  public showMoreButtonTextForNonDesktop: string = 'Show More';
  public showLessButtonTextForNonDesktop: string = 'Show Less';
  public countToDisplayShowMoreButton = 6;
  public isShowMoreButtonClicked: boolean = false;

  constructor(
    public commonService: CommonService,
    public rd: Renderer2,
    public elementRef: ElementRef
  ) { }

  ngOnInit(): void {
    this.commonService._selectedFiltersRefresh.subscribe((filters: object) => {
      if (Array.isArray(filters))
        this.checkedFiltersList = [...<[]>filters]
    });
  }

  clearFilter(event: any, filterType: string) {
    console.warn(event);
    if (event.key === 'Enter' || event.key === ' ' || event.key === 'Spacebar' || event.type == 'click') {
      event.preventDefault();
      event.stopPropagation();
      if (Array.isArray(this.checkedFiltersList))
        this.checkedFiltersList = [...this.checkedFiltersList.filter((c: FilterType) => {
          c.filterType == filterType && this.commonService.trackFilterUpdates(false, 'remove', c.filterType, c.filterName, true);
          return c.filterType !== filterType;
        })];
      this.commonService._postSelectedFilters.next(this.checkedFiltersList);
      this.commonService.trackFilterUpdates(true);
    // 🦻 Announce to screen readers
    if (this.clearStatus) {
      this.clearStatus.nativeElement.textContent = `${filterType} filters have been cleared.`;
      setTimeout(() => {
        if (this.clearStatus) {
          this.clearStatus.nativeElement.textContent = '';
        }
      }, 300);
    }

    }
  }

  onCheckEvent(e: Event, couponCategory: string, label: string, property: string) {
    console.warn(e);
    e.stopImmediatePropagation();
    const filteredData: FilterType = {filterName: couponCategory, filterType: label, filterProperty: property};
    if (Array.isArray(this.checkedFiltersList))
      this.checkedFiltersList = (<HTMLInputElement>e.target)?.checked ? [...this.checkedFiltersList, filteredData] : [...this.checkedFiltersList.filter((c: FilterType) => c.filterName !== couponCategory)];
    this.commonService._postSelectedFilters.next(this.checkedFiltersList);
     const shouldRemoveFilterType = !this.checkedFiltersList.some((c: FilterType) => c.filterName === couponCategory);
    this.commonService.trackFilterUpdates(true, (<HTMLInputElement>e.target)?.checked ? 'add' : 'remove', label, couponCategory, shouldRemoveFilterType);
  }

  public createAriaLabel(index: number, total: number, productName: string, eventGroupName?: string) { 
    return `${eventGroupName?.length ? eventGroupName : 'Event type'} grouping ${index + 1} of ${total} ${productName}`;
  }

  public isChecked(couponCategory: string, label: string) {
    return this.checkedFiltersList.findIndex((f: FilterType) => f.filterName ===(couponCategory)) > -1;

    
  }

  public clearAllFilters($event: any) {
    if ($event.key === 'Enter' || $event.key === ' ' || $event.key === 'Spacebar' || $event.type == 'click') {
    if (this.showFilters) {
      this.showFilters = !this.showFilters;
    }
    const filterHeading = document.getElementById('filters-heading-mobile');
    if(filterHeading) {
      this.commonService.ariaFocusHandler(filterHeading, 'my list page filter button');
    }
    this.checkedFiltersList = [];
    this.commonService._postSelectedFilters.next(this.checkedFiltersList);
    this.commonService.trackFilterUpdates(true, 'remove', 'clearAll', 'clearAll', true);

    // 🦻 Announce to screen readers
    if (this.clearStatus) {
      this.clearStatus.nativeElement.textContent = `all filters have been cleared.`;
      setTimeout(() => {
        if (this.clearStatus) {
          this.clearStatus.nativeElement.textContent = '';
        }
      }, 300);
    }
    }
  }

  onAccordionKeydown(event: KeyboardEvent, prop: string): void {
    const key = event.key;
  
    if (key === 'Enter' || key === ' ' || key === 'Spacebar') {
      event.preventDefault(); // Stops page scroll for Space
      this.toggleAccordion(prop);
    }
  }

  
  public toggleAccordion(prop: string) {
    if (this.selectedFilterType[prop] == undefined) {
      this.selectedFilterType[prop]  = true
    } else {
      this.selectedFilterType[prop]  = !this.selectedFilterType[prop] 
    }
    return this.selectedFilterType[prop];
  }


  public displayFilters() {
    console.log("DISPLAY FILTER FIRIING");
    this.showFilters = !this.showFilters;
    this.showFilters && (window.innerWidth < 768) ? this.rd.addClass(document.body, 'no-overlay-scroll') : this.rd.removeClass(document.body, 'no-overlay-scroll');
      if (this.showFilters) {
          this.applyDOMChanges({
              elem: '.load-more-container',
              attrName: 'aria-hidden',
              action: 'add',
              attrVal: 'true'
          });
          this.applyDOMChanges({
              elem: '.raw-html .ad-container',
              attrName: 'aria-hidden',
              action: 'add',
              attrVal: 'true'
          })
      }
    if (this.showFilters) {
        setTimeout(function () {
          const filterHeading = document.getElementById('filter-heading');
          if(filterHeading) {
            filterHeading.setAttribute('tabindex', '-1');
            filterHeading.focus();
          }
        }, 300);
    }
  }

  public applyAllFilters() {
    this.showFilters = !this.showFilters;
    const filterHeading = document.getElementById('filters-heading-mobile');
    if(filterHeading) {
      this.commonService.ariaFocusHandler(filterHeading, 'my list page filter button');

    }
  }

  public applyDOMChanges(obj: any) {
    const elemName = this.elementRef.nativeElement.querySelector(obj.elem);
    if (elemName) {
        if (obj.action === 'remove') {
            this.rd.removeAttribute(elemName, obj.attrName);
        }
        if (obj.action === 'add') {
            this.rd.setAttribute(elemName, obj.attrName, obj.attrVal)
        }
        if (obj.applyStyle) {
            this.rd.setStyle(elemName, obj.propName, obj.propValue);
        }
    }
  }

  public displayLimitedCategories(data:any) {
    return !this.isShowMoreButtonClicked && data.values.length > this.countToDisplayShowMoreButton;
  }

  public toggleDisplayOfCategories() {
    return this.isShowMoreButtonClicked = !this.isShowMoreButtonClicked;
  }

  public triggerRefocusAfterEnterEvent(event: Event) {
    if (event && event instanceof KeyboardEvent && event.key === 'Enter') {
      const targetElement = event.target as HTMLElement;
      setTimeout( () => {
        targetElement?.focus();
      }, 1000);
    }
  }
}
